// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"fa8e8d39","849":"7766258b"}[chunkId] + ".js";
};